import { useCallback, useEffect } from 'react'
import { useFetch } from "../../api/hooks";
import { useCurrentOrg } from "../../auth/hooks";

const STABLE_EMPTY_ARRAY = []


export const useExistingQuestions = (onResultUpdate) => {
  const [request, { result, loading, called }] = useFetch(
    'Error Fetching Existing Questions.  Please refresh the page and try again',
  )
  const currentOrg = useCurrentOrg()
  const refresh = useCallback(async () => {
    return request({
      onSuccess: result => {
        onResultUpdate && onResultUpdate(result)
      },
      method: 'get',
      url: `/organizations/${currentOrg.id}/question`,
    })
  }, [request])
  useEffect(() => {
    refresh()
  }, [refresh])

  return {
    existingQuestions: result || STABLE_EMPTY_ARRAY,
    loading: loading || !called,
    refresh,
  }
}
